
<!-- Desktop -->
<div class="popover-body">
  <mat-calendar [(selected)]="selected" [startAt]="selected" (selectedChange)="onSelect($event)"></mat-calendar>
  <ion-item *ngIf="includeTime" class="time-select" lines="none">
    <ion-label position="stacked">Time</ion-label>
    <mat-select name="programDateTime" [(ngModel)]="time">
      <mat-option [value]="null">None</mat-option>
      <mat-option value="00:00:00">12:00am</mat-option>
      <mat-option value="01:00:00">1:00am</mat-option>
      <mat-option value="02:00:00">2:00am</mat-option>
      <mat-option value="03:00:00">3:00am</mat-option>
      <mat-option value="04:00:00">4:00am</mat-option>
      <mat-option value="05:00:00">5:00am</mat-option>
      <mat-option value="06:00:00">6:00am</mat-option>
      <mat-option value="07:00:00">7:00am</mat-option>
      <mat-option value="08:00:00">8:00am</mat-option>
      <mat-option value="09:00:00">9:00am</mat-option>
      <mat-option value="10:00:00">10:00am</mat-option>
      <mat-option value="11:00:00">11:00am</mat-option>
      <mat-option value="12:00:00">12:00pm</mat-option>
      <mat-option value="13:00:00">1:00pm</mat-option>
      <mat-option value="14:00:00">2:00pm</mat-option>
      <mat-option value="15:00:00">3:00pm</mat-option>
      <mat-option value="16:00:00">4:00pm</mat-option>
      <mat-option value="17:00:00">5:00pm</mat-option>
      <mat-option value="18:00:00">6:00pm</mat-option>
      <mat-option value="19:00:00">7:00pm</mat-option>
      <mat-option value="20:00:00">8:00pm</mat-option>
      <mat-option value="21:00:00">9:00pm</mat-option>
      <mat-option value="22:00:00">10:00pm</mat-option>
      <mat-option value="23:00:00">11:00pm</mat-option>
    </mat-select>
  </ion-item>
</div>
<!-- Mobile -->
<div class="buttons">
  <div>
    <ion-button size="small" color="danger" (click)="clearDate()" *ngIf="clear && toBind" [disabled]="!toBind">{{'general.removeDate' | translate}}</ion-button>
  </div>
  <div>
    <ion-button size="small" color="secondary" (click)="dismiss()">{{'general.setDate' | translate}}</ion-button>
  </div>
</div>
